"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.873 3.25A1.63 1.63 0 0 0 3.25 4.884v14.232a1.63 1.63 0 0 0 1.623 1.634h14.232a1.63 1.63 0 0 0 1.623-1.634V4.884a1.63 1.63 0 0 0-1.623-1.634zM19.105 22H4.873A2.88 2.88 0 0 1 2 19.116V4.884A2.88 2.88 0 0 1 4.873 2h14.232a2.88 2.88 0 0 1 2.873 2.884v14.232A2.88 2.88 0 0 1 19.105 22m-6.604-9.334c0 .459.493.705.881.494l3.244-1.974c.353-.212.353-.741 0-.988l-3.244-1.974c-.388-.211-.881.035-.881.494v1.017H9.088a1 1 0 0 0-1 1v5.119a1 1 0 1 0 2 0v-4.12H12.5z",
        clipRule: "evenodd"
      }
    )
  }
), m = l(i);
export {
  m as Directions,
  m as default
};
